import React, { useState, useEffect, useMemo } from 'react';
import { Box, LinearProgress } from '@mui/joy';
import { Text } from '../Typography';
import { Icon } from '../../assets';
import ReactApexChart from 'react-apexcharts';
import { useDataProvider } from '../../../mtska-frontend-data-provider';
import { useFormatter } from '../../utils';
import JSONPretty from 'react-json-pretty'

const Bar = ({ title, dataProviderName, icon, filters, format, handleFilterChange, width = '100%', height = 350, showTooltip = true, showToolbar = true, passedItems = null, variant = 'standard', direction = 'vertical' }) => {
    const [items, setItems] = useState();
    const { items: loadedItems, loadAll, loading, reloadCounter } = useDataProvider(dataProviderName);
    const { formatCurrency } = useFormatter();
    const [isStacked, setIsStacked] = useState(false)
    const [maxElementsIfMicro] = useState(5)

    useEffect(() => {
        if (!filters || !dataProviderName || loading) return;

        setItems();
        loadAll(filters);
    }, [filters]);

    useEffect(() => {
        if (typeof items != 'undefined') return;

        //console.info('2 ottengo risposta refresh', reloadCounter, prevReloadCounter.current, items)
        if (loadedItems && typeof loadedItems === 'object' && !Array.isArray(loadedItems) && Object.keys(loadedItems).length > 0) {
            console.info('setto items 1')
            setItems(loadedItems)
        }

        if (passedItems && typeof passedItems === 'object' && !Array.isArray(passedItems) && passedItems?.data) {
            console.info('setto items 2')
            setItems(passedItems.data)
        }
    }, [loadedItems, passedItems]);

    const applyFormat = useMemo(() => {
        return (val) => {
            switch (format) {
                case 'currency':
                    return formatCurrency(val);
                default:
                    return val;
            }
        };
    }, [format, formatCurrency]);

    const series = useMemo(() => {
        if (!items || Array.isArray(items)) return null;

        const { series: dataSeries } = items;

        // micro
        const labels = [...items.labels];
        let values = dataSeries;

        if (variant === 'micro') {
            labels.splice(0, Math.max(0, labels.length - maxElementsIfMicro));
            values = dataSeries.map(s =>
                Array.isArray(s?.data)
                    ? { ...s, data: s.data.slice(-maxElementsIfMicro) }
                    : s
            );
        }

        // STACKED
        if (Array.isArray(values) && values[0]?.data) {
            setIsStacked(true);

            return values.map(serie => ({
                name: serie.name,
                data: labels.map((label, i) => ({
                    x: label,
                    y: serie.data[i]
                }))
            }));
        }

        // NON STACKED
        setIsStacked(false);
        return [{
            name: title,
            data: labels.map((label, i) => ({
                x: label,
                y: values[i]
            }))
        }];
    }, [items, title, variant]);


    const options = useMemo(() => {
        if (!items || !items.labels) return null;
        //console.info('5 formatto options')

        const options = {
            chart: {
                height: height,
                type: 'bar',
                toolbar: { show: showToolbar },
                stacked: isStacked,
                events: {
                    dataPointSelection: (event, chartContext, config) => {
                        const clickedBarIndex = config.dataPointIndex;
                        const label = config.w.globals.labels[clickedBarIndex];

                        if (handleFilterChange) {
                            setTimeout(() => handleFilterChange(label), 100)
                        }
                    }
                }
            },
            tooltip: { enabled: showTooltip },
            legend: { show: false },
            plotOptions: {
                bar: {
                    borderRadius: 5,
                    dataLabels: {
                        position: isStacked ? 'center' : 'top',

                        total: {
                            enabled: true,
                            style: {
                                fontSize: '13px',
                                fontWeight: 900
                            }
                        }
                    },
                    horizontal: direction == 'horizontal'
                }
            },
            dataLabels: {
                enabled: true,
                formatter: applyFormat,
                offsetY: isStacked ? (direction == 'vertical' ? 2 : 0) : (direction == 'vertical' ? -20 : 0),
                offsetX: isStacked ? (direction == 'horizontal' ? 2 : 0) : (direction == 'horizontal' ? -20 : 0),
                style: isStacked ? {
                    fontSize: '11px',
                    fontWeight: 400,
                    colors: ['#FFF']
                } : {
                    fontSize: '12px',
                    fontWeight: '800',
                    colors: ['#304758']
                }
            },
            xaxis: {
                labels: { show: direction == 'vertical' },
                axisBorder: { show: false },
                axisTicks: { show: false },
                tooltip: { enabled: false }
            },
            yaxis: {
                type: 'category',
                labels: { show: direction == 'horizontal' },
                axisBorder: { show: false },
                axisTicks: { show: false },
                tooltip: { enabled: false },
                width: 150
            }
        };

        if (variant == 'micro') {
            if (direction == 'vertical') {
                options.xaxis.labels.show = false;
                options.xaxis.tooltip.enabled = true;
            } else if (direction == 'horizontal') {
                options.yaxis.labels.show = false;
                options.yaxis.tooltip.enabled = true;
            }

            options.dataLabels.enabled = false;
            options.grid = { show: false };
            options.chart.sparkline = { enabled: true };
            options.tooltip.x = { show: false };
            options.tooltip.y = { show: false, title: { formatter: () => '' } };
            options.plotOptions.bar.borderRadius = 2;
        }

        //console.info('6 ottengo options', options.xaxis.categories)
        return options;
    }, [items, applyFormat, isStacked]);

    return (
        !series || !options ? <LinearProgress sx={{ marginBottom: '20px' }} /> :
            <Box className="mtska-chart mtska-chart-timeline">
                <Icon icon={icon} family="fal" />
                <Text level="title-sm" className="title">{title}</Text>

                <Box className="chartwrapper">
                    <ReactApexChart
                        type="bar"
                        options={options}
                        series={series}
                        width={width}
                        height={height}
                    />
                </Box>
            </Box>
    );
};

export default Bar;
